import React from 'react';
import {
  Loader,
  Grid,
  Box,
  ErrorFeedback,
  Heading
} from '@itandi/itandi-bb-ui';
import { useRouter } from 'next/router';
import { useDeals } from '~/hooks/vendors/useDeals';
import { useStatuses } from '~/hooks/vendors/useStatuses';
import type { DealSearchCondition } from '~/models/Deal';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { DealTable } from './table/DealTable';
import {
  buildSearchConditionByParams,
  convertQueryStringUrl
} from '~/utils/DealSearchConditionUtils';
import { PATH } from '~/pages/vendors/deals';
import { MEDIA_QUERY, useMediaQuery } from '~/hooks/useMediaQuery';
import { DealSearch } from '~/components/specifics/vendors/deals/index/search/DealSearch';

export const Page: React.FC = () => {
  const router = useRouter();
  const { match: isSp, isLoaded: windowLoaded } = useMediaQuery(MEDIA_QUERY.sp);
  const [dealSearchCondition, setDealSearchCondition] =
    React.useState<DealSearchCondition>(
      buildSearchConditionByParams(router.query, true)
    );
  // isLoading中用の総ページ数State
  const [totalPage, setTotalPage] = React.useState<number>(1);
  const { data: statuses, isLoading: isStatusLoading } = useStatuses().index();
  const {
    data: paginateDeal,
    mutate: mutatePaginateDeal,
    isLoading: isDealLoading,
    error: paginateDealError
  } = useDeals().index(dealSearchCondition);
  const handleChangeCondition = React.useCallback(
    async (newCondition: DealSearchCondition): Promise<void> => {
      setDealSearchCondition(newCondition);
      const newUrl = convertQueryStringUrl(PATH, newCondition);
      await router.replace(newUrl);
      setTotalPage(paginateDeal?.sumPageCount || totalPage);
      await mutatePaginateDeal?.().then();
    },
    [mutatePaginateDeal, paginateDeal, totalPage, router]
  );
  if (!windowLoaded) {
    return null;
  }
  const statusNames =
    statuses === null
      ? {}
      : Object.fromEntries(statuses.map((status) => [status.id, status.name]));
  return (
    <VendorLayoutV2>
      <Loader isLoading={isDealLoading || isStatusLoading} position="screen" />
      <Box marginTop={8} marginX={16}>
        <Grid gap={8}>
          <Heading as="h1">案件一覧</Heading>
          <DealSearch
            dealSearchCondition={dealSearchCondition}
            handleChangeCondition={handleChangeCondition}
            isSp={isSp}
          />
          {paginateDeal !== null && (
            <DealTable
              deals={paginateDeal.objects}
              dealSearchCondition={dealSearchCondition}
              handleChangeCondition={handleChangeCondition}
              isSp={isSp}
              statusNames={statusNames}
              total={paginateDeal.count}
            />
          )}
          {paginateDealError && paginateDealError.response && (
            <ErrorFeedback>
              {paginateDealError.response.data.message}
            </ErrorFeedback>
          )}
        </Grid>
      </Box>
    </VendorLayoutV2>
  );
};
